import { render, staticRenderFns } from "./Extras.vue?vue&type=template&id=5361f863&scoped=true"
import script from "./Extras.vue?vue&type=script&lang=js"
export * from "./Extras.vue?vue&type=script&lang=js"
import style0 from "./Extras.vue?vue&type=style&index=0&id=5361f863&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5361f863",
  null
  
)

export default component.exports